import Navbar from '../../components/feature/Navbar';
import Footer from '../../components/feature/Footer';
import { mentoriaService } from '../../mocks/services';
import SchemaOrg from '../../components/base/SchemaOrg';

const siteUrl = import.meta.env.VITE_SITE_URL || 'https://example.com';

const mentoriaSchema = {
  '@context': 'https://schema.org',
  '@type': 'Service',
  name: 'Mentoria Individual para Professores em IA',
  description:
    'Mentoria individual para professores que desejam aprender e aplicar Inteligência Artificial na prática pedagógica com acompanhamento personalizado.',
  url: `${siteUrl}/mentoria`,
  provider: {
    '@type': 'Organization',
    name: 'ViaEducacaoCursos',
    url: siteUrl,
  },
  serviceType: 'Mentoria Educacional',
  inLanguage: 'pt-BR',
  areaServed: 'BR',
  audience: {
    '@type': 'Audience',
    audienceType: 'Professores da Educação Básica',
  },
};

export default function MentoriaPage() {
  return (
    <div className="min-h-screen">
      <SchemaOrg id="mentoria" schema={mentoriaSchema} />
      <Navbar />
      <main>
        <section className="pt-32 pb-20 bg-gradient-to-b from-blue-50 to-white">
          <div className="max-w-7xl mx-auto px-6 lg:px-8">
            <div className="text-center mb-16">
              <h1 className="text-5xl lg:text-6xl font-bold text-gray-900 mb-6">
                {mentoriaService.title}
              </h1>
              <p className="text-xl text-gray-600 max-w-3xl mx-auto">
                {mentoriaService.subtitle}
              </p>
            </div>

            <div className="mb-20">
              <img
                src={mentoriaService.image}
                alt="Mentoria Individual"
                className="w-full h-[500px] object-cover rounded-3xl shadow-2xl"
              />
            </div>

            <div className="max-w-4xl mx-auto mb-20">
              <p className="text-xl text-gray-700 leading-relaxed text-center">
                {mentoriaService.description}
              </p>
            </div>

            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8 mb-20">
              {mentoriaService.features.map((feature, index) => (
                <div key={index} className="bg-white rounded-2xl p-8 shadow-lg hover:shadow-xl transition-shadow duration-300">
                  <div className="w-16 h-16 flex items-center justify-center bg-gradient-to-br from-blue-100 to-purple-100 rounded-2xl mb-6">
                    <i className={`${feature.icon} text-3xl text-purple-600`}></i>
                  </div>
                  <h3 className="text-xl font-bold text-gray-900 mb-3">
                    {feature.title}
                  </h3>
                  <p className="text-gray-600 leading-relaxed">
                    {feature.description}
                  </p>
                </div>
              ))}
            </div>

            <div>
              <h2 className="text-4xl font-bold text-gray-900 mb-12 text-center">
                Escolha Seu Plano
              </h2>
              <div className="grid grid-cols-1 md:grid-cols-2 gap-8 max-w-5xl mx-auto">
                {mentoriaService.plans.map((plan, index) => (
                  <div
                    key={index}
                    className={`bg-white rounded-3xl shadow-xl overflow-hidden ${
                      plan.popular ? 'ring-4 ring-purple-600 relative' : ''
                    }`}
                  >
                    {plan.popular && (
                      <div className="absolute top-0 right-0 bg-purple-600 text-white px-6 py-2 text-sm font-bold rounded-bl-2xl">
                        MAIS POPULAR
                      </div>
                    )}
                    <div className="p-8">
                      <h3 className="text-2xl font-bold text-gray-900 mb-2">
                        {plan.name}
                      </h3>
                      <p className="text-gray-600 mb-6">
                        {plan.sessions} • {plan.duration}
                      </p>
                      <div className="mb-8">
                        <span className="text-5xl font-bold text-purple-600">
                          {plan.price}
                        </span>
                      </div>
                      <ul className="space-y-4 mb-8">
                        {plan.features.map((feature, idx) => (
                          <li key={idx} className="flex items-center gap-3">
                            <i className="ri-checkbox-circle-fill text-green-500 text-xl"></i>
                            <span className="text-gray-700">{feature}</span>
                          </li>
                        ))}
                      </ul>
                      <button
                        className={`w-full py-4 font-semibold rounded-full transition-all duration-300 whitespace-nowrap ${
                          plan.popular
                            ? 'bg-gradient-to-r from-blue-600 to-purple-600 text-white hover:shadow-lg'
                            : 'bg-gray-900 text-white hover:bg-gray-800'
                        }`}
                      >
                        Agendar Mentoria
                      </button>
                    </div>
                  </div>
                ))}
              </div>
            </div>
          </div>
        </section>

        <section className="py-20 bg-gray-900">
          <div className="max-w-4xl mx-auto px-6 lg:px-8 text-center">
            <h2 className="text-4xl font-bold text-white mb-6">
              Tem dúvidas sobre a mentoria?
            </h2>
            <p className="text-xl text-gray-300 mb-8">
              Entre em contato conosco e vamos conversar sobre como podemos ajudar você
            </p>
            <button
              onClick={() => document.querySelector('#vapi-widget-floating-button')?.click()}
              className="px-10 py-4 bg-white text-gray-900 font-bold rounded-full hover:shadow-2xl hover:scale-105 transition-all duration-300 whitespace-nowrap"
            >
              Falar com Especialista
            </button>
          </div>
        </section>
      </main>
      <Footer />
    </div>
  );
}